/**
 * Support email helper utilities
 * Centralizes mailto: link construction for support contact across consumers.
 */

export const SUPPORT_EMAIL = 'hello@fathomcoffee.com';

export type SupportContext =
  | { kind: 'order'; orderNumber?: string }
  | { kind: 'tracking'; trackingNumber: string };

/**
 * Build a mailto: href for support, prefilled with subject and body
 * tailored to the context (order lookup vs. tracking number).
 */
export function buildSupportHref(context: SupportContext): string {
  let subject: string;
  let body: string;

  if (context.kind === 'tracking') {
    subject = `Tracking help for ${context.trackingNumber}`;
    body = `Hi Fathom Coffee,\n\nI need help with tracking number ${context.trackingNumber}.\n\nThanks!`;
  } else {
    const orderNumber = context.orderNumber?.trim();
    subject = orderNumber
      ? `Order lookup help for #${orderNumber}`
      : 'Order lookup help';
    body = orderNumber
      ? `Hi Fathom Coffee,\n\nI need help with order #${orderNumber}.\n\nThanks!`
      : 'Hi Fathom Coffee,\n\nI need help with order lookup.\n\nThanks!';
  }

  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
